import React from 'react';
import { Modal } from 'react-bootstrap';
import './style.scss'

const ModalShowSignatureAPR = (props) => {
    // Função para extrair dados de assinatura
    const getSignatureData = () => {
        let responsavel = null
        let tecnico = null
        
        // Nova estrutura: signresponsavel e signtecnico são strings base64 diretas
        if (props.item?.signresponsavel) {
            responsavel = {
                signature: `data:image/png;base64,${props.item.signresponsavel}`,
                name: props.item.responsavel || 'N/A',
                coords: null,
                ip: null
            }
        }
        
        if (props.item?.signtecnico) {
            tecnico = {
                signature: `data:image/png;base64,${props.item.signtecnico}`,
                name: props.item.userName || 'N/A',
                coords: null,
                ip: null
            }
        }
        
        // Estrutura antiga: aprsign com dataresponsavel e datatecnico como JSON
        if (props.item?.aprsign && Object.keys(props.item.aprsign).length > 0) {
            const aprKey = Object.keys(props.item.aprsign)[0]
            const aprData = props.item.aprsign[aprKey]
            
            if (aprData.dataresponsavel) {
                try {
                    const data = JSON.parse(aprData.dataresponsavel)
                    responsavel = {
                        signature: data.signature,
                        name: data.name || 'N/A',
                        coords: data.coords || null,
                        ip: data.ip || null
                    }
                } catch (e) {
                    console.error('Erro ao parsear dataresponsavel:', e)
                }
            }
            
            if (aprData.datatecnico) {
                try {
                    const data = JSON.parse(aprData.datatecnico)
                    tecnico = {
                        signature: data.signature,
                        name: data.name || 'N/A',
                        coords: data.coords || null,
                        ip: data.ip || null
                    }
                } catch (e) {
                    console.error('Erro ao parsear datatecnico:', e)
                }
            }
        }
        
        return { responsavel, tecnico }
    }
    
    const { responsavel, tecnico } = getSignatureData()
    
    return (
            <>
            <Modal
                show={props.show}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => props.onClose()} >
                <Modal.Header closeButton  >
                    <Modal.Title id="contained-modal-title-vcenter">
                        <i className="fa fa-id-badge" /> Visualização de Assinatura APR
                    </Modal.Title>
                </Modal.Header> 
                <Modal.Body style={{ height: "390px", padding: "0px", overflow:"auto" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginLeft: "5px", flexDirection: "column", padding: "10px" }}>
                        <div style={{display:"flex", gap:"10px", marginTop:"15px"}}>
                            {responsavel && (
                                <div style={{ display: "flex", flexDirection: "column", border:"1px dashed #cacaca", padding:"7px", borderRadius:"5px" }}>
                                    <div style={{marginTop:"-18px"}}>
                                        <span style={{background:"#fff",fontWeight: "bold"}}>Responsável</span>
                                    </div>
                                    <span style={{ fontWeight: "bold" }}>Nome</span>
                                    <span>{responsavel.name}</span>
                                    {responsavel.coords && (
                                        <div style={{display:"flex", gap:"15px"}}>
                                            <div style={{display:"flex", flexDirection:"column"}}>
                                                <span style={{ fontWeight: "bold" }}>Localização</span>
                                                <span>{responsavel.coords.latitude}</span>
                                                <span>{responsavel.coords.longitude}</span>
                                            </div>
                                            
                                            {responsavel.ip && (
                                                <div style={{display:"flex", flexDirection:"column"}}>
                                                    <span style={{ fontWeight: "bold" }}>IP</span>
                                                    <span>{responsavel.ip}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <img src={responsavel.signature} alt="Assinatura Responsável" style={{marginTop: "10px"}} />
                                </div>
                            )}
                            
                            {tecnico && (
                                <div style={{ display: "flex", flexDirection: "column", border:"1px dashed #cacaca", padding:"7px", borderRadius:"5px"  }}>
                                    <div style={{marginTop:"-18px"}}>
                                        <span style={{background:"#fff",fontWeight: "bold"}}>Técnico</span>
                                    </div>
                                    <span style={{ fontWeight: "bold" }}>Nome</span>
                                    <span>{tecnico.name}</span>
                                    {tecnico.coords && (
                                        <div style={{display:"flex", gap:"15px"}}>
                                            <div style={{display:"flex", flexDirection:"column"}}>
                                                <span style={{ fontWeight: "bold" }}>Localização</span>
                                                <span>{tecnico.coords.latitude}</span>
                                                <span>{tecnico.coords.longitude}</span>
                                            </div>
                                            
                                            {tecnico.ip && (
                                                <div style={{display:"flex", flexDirection:"column"}}>
                                                    <span style={{ fontWeight: "bold" }}>IP</span>
                                                    <span>{tecnico.ip}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <img src={tecnico.signature} alt="Assinatura Técnico" style={{marginTop: "10px"}} />
                                </div>
                            )}
                            
                            {!responsavel && !tecnico && (
                                <div style={{padding: "20px", textAlign: "center"}}>
                                    <span>Nenhuma assinatura encontrada</span>
                                </div>
                            )}
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer  >
                    <button type="button" className='btn btn-dark' style={{width:"110px", display:"flex",gap:"5px", alignItems:"center", justifyContent:"center"}} onClick={e => props.onClose()}>
                        <i className='fa fa-door-closed'/>
                        <span>Sair</span>
                    </button>
                </Modal.Footer> 
            </Modal>
        </>
    );
};


export default ModalShowSignatureAPR;